import React, { useState } from 'react';
import UserListView from './UserListView';
import { mockUsers } from '../../data/mockUsers';

const Revenue = () => {
  const [users, setUsers] = useState(
    mockUsers.filter(user => user.journeyStage === 'paid')
  );

  const handleFilter = (filter) => {
    // In a real app, this would be an API call
    switch (filter) {
      case 'high-value':
        setUsers(mockUsers.filter(user => 
          user.journeyStage === 'paid' && user.valueScore >= 80
        ));
        break;
      case 'recent':
        setUsers(mockUsers.filter(user => 
          user.journeyStage === 'paid' && 
          user.createdAt >= '2024-02-01'
        ));
        break;
      default:
        setUsers(mockUsers.filter(user => user.journeyStage === 'paid'));
    }
  };

  const handleSearch = (query) => {
    if (!query) {
      setUsers(mockUsers.filter(user => user.journeyStage === 'paid'));
      return;
    }
    const searchTerm = query.toLowerCase();
    setUsers(mockUsers.filter(user => 
      user.journeyStage === 'paid' &&
      (user.name.toLowerCase().includes(searchTerm) ||
       user.email.toLowerCase().includes(searchTerm) ||
       user.tags.some(tag => tag.toLowerCase().includes(searchTerm)))
    ));
  };

  const handleSort = (column, direction) => {
    const sortedUsers = [...users].sort((a, b) => {
      let comparison = 0;
      switch (column) {
        case 'name':
          comparison = a.name.localeCompare(b.name);
          break;
        case 'valueScore':
          comparison = a.valueScore - b.valueScore;
          break;
        case 'resumesCreated':
          comparison = a.resumesCreated - b.resumesCreated;
          break;
        case 'journeyStage':
          comparison = a.journeyStage.localeCompare(b.journeyStage);
          break;
        default:
          comparison = 0;
      }
      return direction === 'asc' ? comparison : -comparison;
    });
    setUsers(sortedUsers);
  };

  const handleSendEmail = () => {
    // In a real app, this would open an email modal or make an API call
    console.log('Sending email to selected users');
  };

  const handleAddTags = () => {
    // In a real app, this would open a tag modal or make an API call
    console.log('Adding tags to selected users');
  };

  const handleExport = (userIds) => {
    // In a real app, this would generate and download a CSV
    console.log('Exporting users:', userIds);
  };

  const totalRevenue = users.reduce((sum, user) => sum + user.conversionValue, 0);
  const averageValue = (totalRevenue / users.length).toFixed(2);

  return (
    <UserListView
      title="Revenue"
      description={`${users.length} paid users, $${totalRevenue.toFixed(2)} total revenue ($${averageValue} average)`}
      users={users}
      onFilter={handleFilter}
      onSearch={handleSearch}
      onSort={handleSort}
      onSendEmail={handleSendEmail}
      onAddTags={handleAddTags}
      onExport={handleExport}
    />
  );
};

export default Revenue; 